import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { ToastProvider, ToastType } from '../../providers/toast/toast';
import { Contacts } from '@ionic-native/contacts';
import { VisitorProvider } from '../../providers/visitor/visitor';
import { VisitorTabsPage } from '../visitor-tabs/visitor-tabs';
import { SelectionModalPage } from '../selection-modal/selection-modal';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';
import { FacilitySelectLocationPage } from '../facility-select-location/facility-select-location';
import { FacilityProvider } from '../../providers/facility/facility';
import { PermissionCheckPipe } from '../../pipes/permission-check/permission-check';

import moment from 'moment';

@IonicPage()
@Component({
  selector: 'page-generate-pass',
  templateUrl: 'generate-pass.html',
})
export class GeneratePassPage {

  title: any;
  date: Date;
  datestring:string
  today: Date;
  tomorrow: Date;
  permissions: any;
  mobile: string;
  name: string;
  companyData: any = null;
  companyName: string;
  cabNo: string = "";
  cabNoArray= ["","","",""];
  searchItems = [];
  hideSearchBox = false;
  disableBtn = false;
  selRegistrationLogin : any;
  bookingDetails : any;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private login: LoginProvider,
    private translate: TranslateService,
    private toast: ToastProvider,
    private perPipe: PermissionCheckPipe,
    private contacts: Contacts,
    private visitorProvider: VisitorProvider,
    private facilityProvider: FacilityProvider,
    private util: UtilService,
    private modalCtrl: ModalController,
    ) {
      this.title = this.navParams.get('purpose');
      this.today = new Date();
      this.tomorrow = new Date();
      this.date = this.today;
      this.tomorrow.setDate(this.today.getDate()+1);
      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
      }
else{

      login.getUserDetails().then(val => {
        this.permissions = val.permissions;
      });
      this.visitorProvider.getCompaniesByCategory(this.title.name).then(val => {
        if(val.status == "success"){
          this.companyData = val.data;
        }
      });
    }
  }

  validate(formData,bookingDetails){
    let regex = "^[a-zA-Z0-9]*[a-zA-Z]+[a-zA-Z0-9]*$";
    var patt = new RegExp(regex);

    if(formData.hasOwnProperty('date_time') && !this.date){
      this.toast.presentToast("Please select a date");
      this.disableBtn=false;
      return false;
    }else if(formData.hasOwnProperty('mobile') && !this.mobile){
      this.toast.presentToast("Please provide a mobile no.");
      this.disableBtn=false;
      return false;
    // }else if(formData.hasOwnProperty('mobile') && this.mobile && String(this.mobile).length != 10){
    //   this.toast.presentToast("Please provide a valid mobile no.");
    //   return false;
    }else if(formData.hasOwnProperty('name') && (!this.name || this.name == "")){
      this.toast.presentToast("Please provide a name");
      this.disableBtn=false;
      return false;
    }
    // else if(formData.hasOwnProperty('name') && !patt.test(this.name)){
    //   this.toast.presentToast("Please provide a valid name");
    //   return false;
    // }
    else if(formData.hasOwnProperty('cab_number') && !this.cabNo){
      this.toast.presentToast("Please provide a cab number");
      this.disableBtn=false;
      return false;
    }else if(formData.hasOwnProperty('cab_number') && this.cabNo && this.cabNo.length != 4){
      this.toast.presentToast("Length of cab no. must be 4");
      this.disableBtn=false;
      return false;
    }else if(formData.hasOwnProperty('company_name') && (!this.companyName || this.companyName == "")){
      this.toast.presentToast("Please provide company name");
      this.disableBtn=false;
      return false;
    }
    else if(bookingDetails){
      // console.log(moment(bookingDetails.from).format('dd-mm-YYYY') ,moment(this.date).format('dd-mm-YYYY'), moment(formData.date_time).format('dd-mm-YYYY') ;
      if(formData.date_time != moment(bookingDetails.from).format('YYYY-MM-DD')){
        this.toast.presentToast("Parking Date and Pass Date should be same !");
        return false;
      }
    }
    return true;
  }

  createPass(){
    this.disableBtn=true;
    this.name = (this.name)?this.name.trim():null;
    this.cabNo = this.cabNoArray[0] + this.cabNoArray[1] + this.cabNoArray[2] + this.cabNoArray[3];
    let formData = this.getFormData();
    if(this.validate(formData,this.bookingDetails)){
      this.visitorProvider.generatePass(formData).then(val => {
        
        if(val.status == "success"){
          this.toast.presentToast("Pass created successfully", ToastType.success);
        //  onAddBooking   add permission herr 
        if(this.bookingDetails){
          this.onAddBooking(val.data.id)
        }
            this.navCtrl.push(
            VisitorTabsPage, {index:1}
          ).then(() =>  {
            this.util.clearNavStack(this.navCtrl);
          });
        }else{
          this.toast.presentToast(val.message, ToastType.danger);
          this.disableBtn=false;
        }
      }).catch(val => {
        this.toast.presentToast("Unable to create pass", ToastType.danger);
        this.disableBtn=false;
      });
    }
  }

  getFormData(){
    switch(this.title.name){
      case 'guest':
        return {
          date_time: this.getFormDate(),
          mobile: this.mobile,
          name: this.name,
          type: 'guest'
        };
      case 'cab':
        return {
          date_time: this.getFormDate(),
          company_name: this.companyName,
          cab_number: this.cabNo,
          type: 'cab'
        };
      case 'delivery':
        return {
          date_time: this.getFormDate(),
          company_name: this.companyName,
          type: 'delivery'
        };
    }
  }

  pickContact(){
    this.contacts.pickContact().then(val => {
      if(val.displayName)
        this.name = val.displayName;
      if(val.phoneNumbers.length > 0){
        let mobile = val.phoneNumbers[0].value.replace('+91','');
        this.mobile = mobile.replace(/ /g,'');
      }
    });
  }

  openCmpSelectionModal(){
    let modal = this.modalCtrl.create(SelectionModalPage,
      {data: this.companyData, category: this.title.name}
    );
    modal.present();
    modal.onDidDismiss(data => {
      this.companyName = data;
    });
  }

  getFormDate(){

    if(this.date){
      let d = this.date,
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
  
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
  
      return [year, month, day].join('-');
    }
    return this.date;
  }

  searchCompany(val){
    this.hideSearchBox = false;
    let items = this.companyData;
    if(items && val && val.trim() != ''){
      items = items.filter((item) => {
        if(item.name.toLowerCase().indexOf(val.toLowerCase()) > -1){
          return true;
        }else{
          return false;
        }
      });
      this.searchItems = items;
    }else{
      this.searchItems = [];
    }
  }

  setcompanyName(item){
    this.companyName = item.name;
    this.hideSearchBox = true;
  }

  setDate($event){
   this.datestring=$event.toISOString()
    this.date = $event;
  }

  setTomorrow(){
    this.date = this.tomorrow;
    console.log(this.date);
    
  }

  setToday(){
    this.date = this.today;
  }

  next(event, value, prev, next) {
    var patt = new RegExp('^[0-9]+$');
    var key = event.keyCode || event.charCode;

    if( (key == 8 || key == 46)){
      if(prev){
        prev.setFocus();
      }
    }
    else if(patt.test(value)){
      if(next){
        next.setFocus();
      }
    }
  }


  goToAmenityPage(){
    let formData = this.getFormData();
    if(this.validate(formData,'')){
      let modal =   this.modalCtrl.create(FacilitySelectLocationPage,{
       name:this.name,
       mobile:this.mobile,
       type:'PARKING',
       openModal:true,
       date:formData.date_time,
     })
     modal.present();
     modal.onDidDismiss(data => {
       console.log(data,"when popup close")
     this.bookingDetails = data
     this.validate(formData,this.bookingDetails);
    });
  }

  }

checkPermission(mod,type){
 
  
    let perPipe = new PermissionCheckPipe();
if (perPipe.transform(this.permissions, mod, type)) {
return true
}
else{
  return false
}
   

}
onAddBooking(id){
  this.facilityProvider.bookSlot(this.bookingDetails.locationId, this.bookingDetails.from, this.bookingDetails.to,this.bookingDetails.data,id ).then(val =>{
    if(val.status == "success"){
     return val.data
    }else{
      this.toast.presentToast(val.message);
    }
  });
}
  
  // next(event, prev, next) {
  //   var patt = new RegExp('^[0-9]+$');
  //   var key = event.keyCode || event.charCode;

  //   if( (key == 8 || key == 46) && this.cabNo.length > 0){
  //     this.cabNo = this.cabNo.slice(0,-1);
  //     if(prev){
  //       prev.setFocus();
  //     }
  //   }
  //   else if(patt.test(event.key) && this.cabNo.length < 4){
  //     this.cabNo += event.key;
  //     if(next){
  //       next.setFocus();
  //     }
  //   }
  //   console.log(this.cabNo);
  // }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GeneratePassPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/generate-pass/generate-pass.ts